<template>
  <div>
    <Breadcrumb />
    <el-card class="box-card mt-20">
      <div slot="header" class="clearfix">
        <span>区域分类信息添加</span>
      </div>
      <el-form
        ref="productTypeForm"
        :model="productTypeInfo"
        :rules="rules"
        class="add-form"
        :label-position="labelPosition"
        label-width="140px"
      >
        <div class="add-form-item">
          <el-form-item label="区域名称：" prop="typeName">
            <el-input v-model="productTypeInfo.typeName"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 最多不超过25个字符</span>
        </div>
        <div class="add-form-item">
          <el-form-item label="区域编码：" prop="typeCode">
            <el-input v-model="productTypeInfo.typeCode"></el-input>
          </el-form-item>
          <span class="validate ml-20"> * 编码范围内必须在100至999之间</span>
        </div>
        <br />
        <el-form-item>
          <el-button type="primary" @click="add">添加</el-button>
          <el-button @click="goBack">返回</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from "@/components/Breadcrumb";
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      labelPosition: "left",
      roleOptions: [],
      productTypeInfo: {
        productTypeId: "",
        typeName: "",
        typeCode: ""
      },
      rules: {
        typeName: [
          {
            max: 20,
            message: "最多输入20个字符",
            trigger: "change"
          }
        ],
        typeCode: [
          {
            validator: this.validateCom,
            message: "编码范围内必须在100至999之间的正整数",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
    validateCom(rule, value, callback) {
      const one = Number(value);
      if (Number.isInteger(one)) {
        if (one < 100) {
          return callback(new Error("输入值必须大于99}"));
        } else if (one > 999) {
          return callback(new Error("输入值必须小于1000"));
        }
        return callback();
      }
      return callback(new Error("输入值必须为正整数"));
    },
    add() {
      let _this = this;
      _this.$refs.productTypeForm.validate(isPass => {
        if (isPass) {
          let param = {
            url: "/api/productType/saveProductTypeInfo",
            params: {
              typeName: _this.productTypeInfo.typeName,
              typeCode: _this.productTypeInfo.typeCode
            }
          };

          _this.$Api
            .post(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.$message({
                  message: "区域分类信息添加成功",
                  type: "success"
                });
                this.$router.push({
                  name: "productTypeIndex"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        } else {
          _this.$message({
            message: "请完善区域分类信息!",
            type: "warning"
          });
        }
      });
    }
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  width: 700px
  display: flex
  .el-form-item
    width: 460px
  .validate
    height: 40px
    line-height: 40px
    font-size: 14px
    color: #E6A23C
</style>
